import * as PIXI from 'pixi.js';
import { FloadReader } from './heartRate';

function makePos(height: number, lowValue: number, highValue: number, rawValue: number) {
  if (rawValue < lowValue) {
    return height;
  }
  if (rawValue > highValue) {
    return 0;
  }

  const mvPerY = height / (highValue - lowValue);
  const y = height - mvPerY * (
    rawValue + (highValue - lowValue) / 2 - Math.abs(
      Math.abs(highValue) - Math.abs(lowValue),
    ) / 2
  );
  return y;
}

function makePosPlus(height: number, lowValue: number, highValue: number, rawValue: number) {
  if (rawValue < lowValue) {
    return height;
  }
  if (rawValue > highValue) {
    return 0;
  }

  const mvPerY = height / (highValue - lowValue);
  const y = height - mvPerY * (rawValue - lowValue);
  return y;
}

function minMax(prev: number, current: number) {
  if (Math.abs(prev) < Math.abs(current)) {
    return current;
  }
  return prev;
}

function getData(reader: FloadReader, aveWidth: number) {
  if (aveWidth === 1) {
    return reader.next();
  }
  const ret = reader.chunk(aveWidth);
  return ret.reduce(minMax, 0);
}

export class PixiChart {
  private contaienr: PIXI.Container;
  private line: PIXI.Graphics;
  private currentPos = 0;
  private mask: PIXI.Graphics;

  constructor(private width: number, private height: number, private lineColor: number) {
    this.contaienr = new PIXI.Container();
    this.mask = new PIXI.Graphics();

    this.line = new PIXI.Graphics();
    // this.line.mask = this.mask;
    // this.mask.width = 0;

    this.contaienr.addChild(this.line);
    this.line.lineStyle(1, this.lineColor);

    this.mask.beginFill(0)
      .drawRect(0, 0, this.width, this.height)
      .endFill();
    // this.line.addChild(this.mask);
    this.mask.position.x = -this.width;

    // this.line.mask = this.mask;
    this.contaienr.addChild(this.mask);
    this.contaienr.mask = this.mask;
  }

  public draw2(vals: [number, number][], low: number, high: number) {
    this.line.cacheAsBitmap = false;
    this.line.clear();
    this.line.lineStyle(1, this.lineColor);

    if (vals.length > 0) {
      this.line.moveTo(0, makePosPlus(this.height, low, high, vals[0][1]));
    }
    vals.forEach((v) => {
      const val = makePosPlus(this.height, low, high, v[1]);
      this.line.lineTo((v[0] / (15000 * 4 * 10)) * 1260, val);
    });
    const last = vals[vals.length - 1];
    if (last) {
      this.line.lineTo(1260, makePosPlus(this.height, low, high, last[1]));
    }

    this.line.cacheAsBitmap = true;
  }

  public draw(
    reader: FloadReader,
    length: number,
    aveCount: number,
    low: number,
    high: number,
    offset = 0,
  ) {
    this.line.cacheAsBitmap = false;
    this.line.clear();
    this.line.lineStyle(1, this.lineColor);

    for (let i = 0; i < length; i += 1) {
      if (reader.isEnd()) {
        break;
      }
      const v = getData(reader, aveCount);
      const val = makePos(this.height, low, high, v);
      if (i < 42) {
        this.line.moveTo(i, val + offset);
      } else {
        this.line.lineTo(i, val + offset);
      }
    }

    this.line.cacheAsBitmap = true;
  }

  public getContainer() {
    return this.contaienr;
  }

  public tick(current: number, max: number) {
    if (current > max) {
      this.mask.x = 0;
      return;
    }
    const per = current / max;
    const pos = this.width - per * this.width;
    this.mask.x = Math.min(max, -pos);
  }
}

export default {
  PixiChart,
};
